import React, { Component } from "react";
import { SwitchComponent } from "@syncfusion/ej2-react-buttons";
// import DatePicker from 'react-datepicker2';
import { Button, Image } from "react-bootstrap";
import exportall from "../assets/exportall.png";
// import portfolioicon from '../assets/portfolioicon.png'
import { MagicSpinner } from "react-spinners-kit";
import charticon from "../assets/charticon.png";
import moment from "moment-jalaali";
import {
  Chart as LineChart,
  CommonSeriesSettings,
  ArgumentAxis,
  Grid,
  Crosshair,
  Point,
  Tooltip,
  CommonAxisSettings,
  CommonAnnotationSettings,
  HoverStyle,
} from "devextreme-react/chart";
import { Series, Label, Font, Legend } from "devextreme-react/pie-chart";
import ContextMenuComponent from "../components/ContextMenuComponent";
// import { faEllipsisV } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { toast } from "react-toastify";
// import { Typeahead } from 'react-bootstrap-typeahead';

// import { exportFromMarkup } from 'devextreme/viz/export';

import DatePicker, { DateObject } from "react-multi-date-picker";
// import Toolbar from "react-multi-date-picker/plugins/toolbar"
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/layouts/prime.css";
import "react-multi-date-picker/styles/colors/bluee.css";

export default class Chart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentReportType: "last",
      dateValue: moment().format("jYYYY/jMM/jDD"),
      dateValue1: moment().add(-1, "months").format("jYYYY/jMM/jDD"),
      maxDate: moment().add(0, "days").format("jYYYY/jMM/jDD"),
      maxDateStart: moment().add(-1, "days").format("jYYYY/jMM/jDD"),
      minDate: moment().add(-1, "months").add(1, "day").format("jYYYY/jMM/jDD"),
      chartData: [],
      removeFilter: false,
      fetchCancel: false,
      buttonDisabled: false,
      selectedDate1: moment().add(-1, "months").format("jYYYY-jMM-jDD"),
      selectedDate2: moment().format("jYYYY-jMM-jDD"),
      energySources: [
        { value: "portfolioNAV", name: "ارزش کل پرتفوی" },
        { value: "cash_sum", name: "نقدینگی" },
        { value: "total", name: "مجموع دارایی" },
      ],
      statusSelection: null,
    };

    this.reportTypeSwitch = React.createRef();

    this.chartRef = React.createRef();
    this.conmenu = React.createRef();
    this.container = React.createRef();
    this.datepickerr1 = React.createRef();
    this.datepickerr = React.createRef();

    this.controller = new AbortController();
  }

  componentDidMount() {
    this.props.pageIsopen();
    this.chartFileterByDate();
  }

  convertDate(date) {
    let timee = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(date);
    let year = "";
    let month = "";
    let day = "";
    timee.forEach((element) => {
      if (element.type === "year") {
        year = element.value;
      } else if (element.type === "month") {
        month = element.value;
      } else if (element.type === "day") {
        day = element.value;
      }
    });
    let formatedDate = year + "/" + month + "/" + day;
    let pdate = moment(formatedDate, "YYYY/MM/DD").format("jYYYY-jMM-jDD");
    return pdate;
  }

  chartFileterByDate() {
    // let date1=this.convertDate(this.state.dateValue1);
    // let date2=this.convertDate(this.state.dateValue);

    // alert(this.state.dateValue1)
    // alert(this.state.dateValue)
    let date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
      "jYYYY-jMM-jDD"
    );
    let date2 = moment(this.state.dateValue, "jYYYY/jMM/jDD").format(
      "jYYYY-jMM-jDD"
    );
    // let date1=this.state.dateValue1.replace('/','-');
    // let date2=this.state.dateValue.replace('/','-');

    let date11 = this.state.dateValue1;
    let date22 = moment().add(-1, "months").format("jYYYY/jMM/jDD");
    let date33 = this.state.dateValue;
    let date44 = moment().format("jYYYY/jMM/jDD");

    // console.log("date1",date1);
    // console.log("date2",date2);
    // console.log("date11",date11);
    // console.log("date22",date22);
    // console.log("date33",date33);
    // console.log("date44",date44);
    // return

    if (date11 !== date22 || date33 !== date44) {
      this.setState({ removeFilter: true });
    } else {
      this.setState({ removeFilter: false });
    }

    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      init: date1.toString(),
      last: date2.toString(),
      basket_id: this.props.portfolioID,
      type: this.state.currentReportType,
    };

    // console.log(data);

    this.controller = new AbortController();
    var signal = this.controller.signal;

    this.setState({ isLoading: true });
    fetch("/api/calculatePortfolioNAVInterval", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      signal,
    })
      .then((res) => res.json())
      .then((resultt) => {
        // console.log(resultt);
        if (resultt.status === 200) {
          this.setState({
            chartData: resultt.message,
            selectedDate1: date1,
            selectedDate2: date2,
          });
          this.setState({ isLoading: false });
        } else {
          this.props.history.push("/Login");
        }
      })
      .catch((err) => {
        if (this.state.fetchCancel) {
          this.setState({ fetchCancel: false }, () => {
            this.chartFileterByDate();
          });
        } else {
          this.setState({ isLoading: false });
        }
      });
  }

  chartExportExcelClicked() {
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      init: this.state.selectedDate1,
      last: this.state.selectedDate2,
      basket_id: this.props.portfolioID,
      type: this.state.currentReportType,
      toXls: true,
    };

    // alert(JSON.stringify(data))
    // return;

    // this.controller = new AbortController();
    // var signal = this.controller.signal;

    this.setState({ buttonDisabled: true });
    fetch("/api/calculatePortfolioNAVInterval", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.body)
      .then((stream) => new Response(stream))
      .then((response) => response.blob())
      .then((blob) => URL.createObjectURL(blob))
      .then((url) => {
        const link = document.createElement("a");
        link.href = url;
        // link.download = "burcel_"+ Date.now().toString() + ".xlsx";
        link.download =
          "ChartData_" +
          this.state.selectedDate1 +
          "-" +
          this.state.selectedDate2 +
          "(" +
          this.props.selectedPortfolioName +
          ").xlsx";
        document.body.appendChild(link);
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
        document.body.removeChild(link);
        this.setState({ buttonDisabled: false });
      })
      .catch((err) => {
        toast.error(err.message, {
          position: toast.POSITION.BOTTOM_LEFT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        });
        this.setState({ buttonDisabled: false });
      });
  }

  reportTypeChanged() {
    if (this.reportTypeSwitch.current.checked) {
      this.setState({ currentReportType: "end" }, () => {
        this.chartFileterByDate();
      });
    } else {
      this.setState({ currentReportType: "last" }, () => {
        this.chartFileterByDate();
      });
    }
  }

  fixNumber(str) {
    var persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  }

  dateChange1(dateValue) {
    try {
      this.datepickerr.current.closeCalendar();
      this.datepickerr1.current.closeCalendar();
    } catch (error) {}
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    let min = this.fixNumber(
      new DateObject(dateValue).add(1, "days").format("YYYY/MM/DD")
    );
    this.setState({ dateValue1: value, minDate: min });
  }

  dateChange(dateValue) {
    try {
      this.datepickerr.current.closeCalendar();
      this.datepickerr1.current.closeCalendar();
    } catch (error) {}

    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));

    this.setState({
      dateValue: value,
      maxDateStart: this.fixNumber(
        new DateObject(dateValue).add(-1, "day").format("YYYY/MM/DD")
      ),
    });
  }

  removeFilter() {
    this.setState(
      {
        dateValue: moment().format("jYYYY/jMM/jDD"),
        dateValue1: moment().add(-1, "months").format("jYYYY/jMM/jDD"),
        maxDate: moment().add(0, "days").format("jYYYY/jMM/jDD"),
        maxDateStart: moment().add(-1, "days").format("jYYYY/jMM/jDD"),
        fetchCancel: true,
      },
      () => {
        if (this.state.isLoading) {
          this.controller.abort();
        } else {
          this.chartFileterByDate();
        }

        this.setState({ removeFilter: false });
      }
    );
  }

  legendClickHandler(e) {
    const series = e.target;
    if (series.isVisible()) {
      series.hide();
    } else {
      series.show();
    }
  }

  menuClicked(target) {
    if (!this.state.isLoading) {
      switch (target) {
        case "Excel": {
          this.chartExportExcelClicked();
          break;
        }
        case "PNG": {
          this.chartRef.current.instance.exportTo(
            "chart_" + Date.now().toString(),
            "PNG"
          );
          break;
        }
        case "JPG": {
          this.chartRef.current.instance.exportTo(
            "chart_" + Date.now().toString(),
            "JPG"
          );
          break;
        }
        case "SVG": {
          this.chartRef.current.instance.exportTo(
            "chart_" + Date.now().toString(),
            "SVG"
          );
          break;
        }
        case "PDF": {
          this.chartRef.current.instance.exportTo(
            "chart_" + Date.now().toString(),
            "PDF"
          );
          break;
        }
        case "GIF": {
          this.chartRef.current.instance.exportTo(
            "chart_" + Date.now().toString(),
            "GIF"
          );
          break;
        }
        default: {
          this.chartRef.current.instance.exportTo(
            "chart_" + Date.now().toString(),
            "PNG"
          );
          break;
        }
      }
    }
  }

  btnClick() {
    // this.conmenu.current.showMenu(this.targett.getBoundingClientRect().bottom-this.container.current.getBoundingClientRect().top+"px",this.targett.getBoundingClientRect().left-this.container.current.getBoundingClientRect().left+"px");

    this.conmenu.current.showMenu(
      this.targett.getBoundingClientRect().bottom + "px",
      this.targett.getBoundingClientRect().left + "px"
    );
  }

  onStatusChange(event) {
    // console.log(event);
    this.setState({ statusSelection: event });
  }

  render() {
    return (
      <div
        ref={this.tabcontainer}
        className={
          this.props.tabselectedindex === 0
            ? "tabsContainerChart rmvStartRadius"
            : "tabsContainerChart"
        }
      >
        <div className="tabsAllContentChart">
          <div className="tabsContentChart">
            {this.props.pageWidth >= 900 && (
              <div ref={this.container} className="tabsContentHeader">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "12px",
                    color: "var(--gray4)",
                  }}
                >
                  <img
                    src={charticon}
                    style={{ height: "20px", marginLeft: "10px" }}
                    alt="chart"
                  />
                  <div>نمودار</div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row-reverse",
                    alignItems: "center",
                    flexWrap: "wrap",
                    flex: "1",
                  }}
                >
                  <Button
                    variant="secondary"
                    id="targett"
                    ref={(scope) => (this.targett = scope)}
                    className="filterButton"
                    onClick={this.btnClick.bind(this)}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row-reverse",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ flexDirection: "row", display: "flex" }}>
                        <div style={{ marginLeft: "10px", height: "100%" }}>
                          فایل خروجی
                        </div>
                        <Image style={{ height: "16px" }} src={exportall} />
                      </div>
                    </div>
                  </Button>
                  {/* <Button variant="secondary" className="filterButton" disabled={this.state.buttonDisabled} onClick={this.chartExportExcelClicked.bind(this)}><div style={{display:'flex',flexDirection:'row-reverse',justifyContent:'center',alignItems:'center'}}>{this.state.buttonDisabled && <Spinner className="spinnerStyle" animation="border" />}{!this.state.buttonDisabled && <div style={{flexDirection:'row',display:'flex'}}><div style={{marginLeft:'10px',height:'100%', paddingTop:'4px'}}>فایل اکسل</div><Image style={{height:'16px'}} src={exportexcel} /></div>}</div></Button> */}
                  <div
                    style={{
                      flexWrap: "wrap",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      fontSize: "12px",
                    }}
                  >
                    <div
                      style={{
                        margin: "2px 10px 0px 10px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      آخرین قیمت
                    </div>
                    <SwitchComponent
                      checked={false}
                      cssClass="bar-color"
                      ref={this.reportTypeSwitch}
                      change={this.reportTypeChanged.bind(this)}
                    />
                    <div
                      style={{
                        margin: "2px 10px 0px 10px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      قیمت پایانی
                    </div>

                    <div
                      style={{
                        margin: "0px 10px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ margin: "0px 5px", whiteSpace: "nowrap" }}>
                        شروع بازه:
                      </div>
                      {/* <DatePicker
                                            max={this.state.maxDateStart}
                                            className="form-control inputStyleFilter"
                                            timePicker={false}
                                            isGregorian={false}
                                            ref={(scope) => this.datepickerr1 = scope}
                                            onChange={valuee => this.dateChange1(valuee)}
                                            value={this.state.dateValue1}/> */}

                      <DatePicker
                        ref={this.datepickerr1}
                        value={this.state.dateValue1}
                        inputClass="form-control inputStyleFilter"
                        calendar="persian"
                        locale="fa"
                        weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                        format="YYYY/MM/DD"
                        animation
                        className="bluee"
                        onChange={(valuee) => this.dateChange1(valuee)}
                        maxDate={this.state.maxDateStart}
                        editable={false}
                        inputMode="none"
                        placeholder="شروع"
                        // plugins={[
                        //     <Toolbar
                        //         position="bottom"
                        //         sort={["today"]}
                        //     />
                        // ]}
                      />
                    </div>

                    <div
                      style={{
                        margin: "0px 10px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ margin: "0px 5px", whiteSpace: "nowrap" }}>
                        پایان بازه:
                      </div>
                      {/* <DatePicker
                                            min={this.state.minDate}
                                            max={this.state.maxDate}
                                            className="form-control inputStyleFilter"
                                            timePicker={false}
                                            isGregorian={false}
                                            ref={(scope) => this.datepickerr = scope}
                                            onChange={valuee => this.dateChange(valuee)}
                                            value={this.state.dateValue}
                                        /> */}

                      <DatePicker
                        ref={this.datepickerr}
                        value={this.state.dateValue}
                        inputClass="form-control inputStyleFilter"
                        calendar="persian"
                        locale="fa"
                        weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                        format="YYYY/MM/DD"
                        animation
                        className="bluee"
                        onChange={(valuee) => this.dateChange(valuee)}
                        minDate={this.state.minDate}
                        maxDate={this.state.maxDate}
                        editable={false}
                        inputMode="none"
                        placeholder="پایان"
                        // plugins={[
                        //     <Toolbar
                        //         position="bottom"
                        //         sort={["today"]}
                        //     />
                        // ]}
                      />
                    </div>
                    <Button
                      onClick={this.chartFileterByDate.bind(this)}
                      style={{
                        padding: "0px 10px",
                        fontSize: "10px",
                        marginLeft: "10px",
                        height: "32px",
                        whiteSpace: "nowrap",
                        color: "white",
                      }}
                    >
                      اعمال فیلتر
                    </Button>

                    {this.state.removeFilter && (
                      <Button
                        variant="danger"
                        onClick={this.removeFilter.bind(this)}
                        style={{
                          padding: "0px 10px",
                          fontSize: "10px",
                          marginLeft: "10px",
                          height: "32px",
                          whiteSpace: "nowrap",
                          color: "white",
                        }}
                      >
                        حذف فیلتر
                      </Button>
                    )}
                    {/* <Button variant="secondary" id="targett" ref={(scope) => this.targett = scope} className="filterButton" onClick={this.btnClick.bind(this)}><div style={{display:'flex',flexDirection:'row-reverse',justifyContent:'center',alignItems:'center'}}><div style={{flexDirection:'row',display:'flex'}}><div style={{marginLeft:'10px',height:'100%', paddingTop:'4px'}}>فایل خروجی</div><Image style={{height:'16px'}} src={exportexcel} /></div></div></Button> */}
                  </div>
                </div>
                <ContextMenuComponent
                  data={[
                    { title: "Excel", target: "Excel" },
                    { title: "PNG", target: "PNG" },
                    { title: "JPG", target: "JPG" },
                    { title: "GIF", target: "GIF" },
                    { title: "SVG", target: "SVG" },
                    { title: "PDF", target: "PDF" },
                  ]}
                  isChart={true}
                  targett={this.targett}
                  menuClicked={this.menuClicked.bind(this)}
                  ref={this.conmenu}
                />
              </div>
            )}

            {this.props.pageWidth < 900 && (
              <div ref={this.container} className="tabsContentHeaderSmall">
                <div className="tabsContentHeaderChild1">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "var(--gray4)",
                    }}
                  >
                    <img
                      src={charticon}
                      style={{ height: "20px", marginLeft: "10px" }}
                      alt="chart"
                    />
                    <div>نمودار</div>
                  </div>
                  {this.props.pageWidth < 500 && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          marginLeft: "5px",
                          marginRight: "0",
                          whiteSpace: "nowrap",
                        }}
                      >
                        آخرین
                      </div>
                      <SwitchComponent
                        checked={false}
                        cssClass="bar-color"
                        ref={this.reportTypeSwitch}
                        change={this.reportTypeChanged.bind(this)}
                      />
                      <div style={{ margin: "0px 5px", whiteSpace: "nowrap" }}>
                        پایانی
                      </div>
                    </div>
                  )}
                  <Button
                    variant="secondary"
                    id="targett"
                    ref={(scope) => (this.targett = scope)}
                    className="filterButton"
                    onClick={this.btnClick.bind(this)}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row-reverse",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ flexDirection: "row", display: "flex" }}>
                        <Image style={{ height: "16px" }} src={exportall} />
                      </div>
                    </div>
                  </Button>
                  {/* <Button variant="secondary" className="filterButton" disabled={this.state.buttonDisabled} onClick={this.chartExportExcelClicked.bind(this)}><div style={{display:'flex',flexDirection:'row-reverse',justifyContent:'center',alignItems:'center'}}>{this.state.buttonDisabled && <Spinner className="spinnerStyle" animation="border" />}{!this.state.buttonDisabled && <div style={{flexDirection:'row',display:'flex'}}><div style={{marginLeft:'10px',height:'100%', paddingTop:'4px'}}>فایل اکسل</div><Image style={{height:'16px'}} src={exportexcel} /></div>}</div></Button> */}
                </div>

                <div
                  className="tabsContentHeaderChild2"
                  style={{ flexDirection: "row-reverse" }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent:
                        this.props.pageWidth >= 500
                          ? "space-between"
                          : "flex-end",
                      width: "100%",
                    }}
                  >
                    {this.props.pageWidth >= 500 && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            marginLeft: "5px",
                            marginRight: "0",
                            whiteSpace: "nowrap",
                          }}
                        >
                          آخرین
                        </div>
                        <SwitchComponent
                          checked={false}
                          cssClass="bar-color"
                          ref={this.reportTypeSwitch}
                          change={this.reportTypeChanged.bind(this)}
                        />
                        <div
                          style={{ margin: "0px 5px", whiteSpace: "nowrap" }}
                        >
                          پایانی
                        </div>
                      </div>
                    )}

                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div
                        style={{
                          margin: "0px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            marginRigh: "0px",
                            marginLeft: "3px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          شروع:
                        </div>
                        {/* <DatePicker
                                                    max={this.state.maxDateStart}
                                                    className="form-control inputStyleFilter"
                                                    timePicker={false}
                                                    isGregorian={false}
                                                    ref={(scope) => this.datepickerr1 = scope}
                                                    onChange={valuee => this.dateChange1(valuee)}
                                                    value={this.state.dateValue1}/> */}
                        <DatePicker
                          ref={this.datepickerr1}
                          value={this.state.dateValue1}
                          inputClass="form-control inputStyleFilter"
                          calendar="persian"
                          locale="fa"
                          weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                          format="YYYY/MM/DD"
                          animation
                          className="rmdp-mobile bluee"
                          onChange={(valuee) => this.dateChange1(valuee)}
                          maxDate={this.state.maxDateStart}
                          editable={false}
                          inputMode="none"
                          placeholder="شروع"
                          // plugins={[
                          //     <Toolbar
                          //         position="bottom"
                          //         sort={["today"]}
                          //     />
                          // ]}
                        />
                      </div>

                      <div
                        style={{
                          margin: "0px 5px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{ margin: "0px 3px", whiteSpace: "nowrap" }}
                        >
                          پایان:
                        </div>
                        {/* <DatePicker
                                                    min={this.state.minDate}
                                                    max={this.state.maxDate}
                                                    className="form-control inputStyleFilter"
                                                    timePicker={false}
                                                    isGregorian={false}
                                                    ref={(scope) => this.datepickerr = scope}
                                                    onChange={valuee => this.dateChange(valuee)}
                                                    value={this.state.dateValue}
                                                /> */}
                        <DatePicker
                          ref={this.datepickerr}
                          value={this.state.dateValue}
                          inputClass="form-control inputStyleFilter"
                          calendar="persian"
                          locale="fa"
                          weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                          format="YYYY/MM/DD"
                          animation
                          className="rmdp-mobile bluee"
                          onChange={(valuee) => this.dateChange(valuee)}
                          minDate={this.state.minDate}
                          maxDate={this.state.maxDate}
                          editable={false}
                          inputMode="none"
                          placeholder="پایان"
                          // plugins={[
                          //     <Toolbar
                          //         position="bottom"
                          //         sort={["today"]}
                          //     />
                          // ]}
                        />
                      </div>

                      <Button
                        onClick={this.chartFileterByDate.bind(this)}
                        style={{
                          padding: "0px 5px",
                          fontSize: "10px",
                          height: "32px",
                          whiteSpace: "nowrap",
                          color: "white",
                        }}
                      >
                        اعمال
                      </Button>
                      {this.state.removeFilter && (
                        <Button
                          variant="danger"
                          onClick={this.removeFilter.bind(this)}
                          style={{
                            padding: "0px 5px",
                            fontSize: "10px",
                            marginRight: "5px",
                            height: "32px",
                            whiteSpace: "nowrap",
                            color: "white",
                          }}
                        >
                          حذف
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
                <ContextMenuComponent
                  data={[
                    { title: "Excel", target: "Excel" },
                    { title: "PNG", target: "PNG" },
                    { title: "JPG", target: "JPG" },
                    { title: "GIF", target: "GIF" },
                    { title: "SVG", target: "SVG" },
                    { title: "PDF", target: "PDF" },
                  ]}
                  isChart={true}
                  targett={this.targett}
                  menuClicked={this.menuClicked.bind(this)}
                  ref={this.conmenu}
                />
              </div>
            )}
            {!this.state.isLoading && (
              <LineChart
                ref={this.chartRef}
                onLegendClick={this.legendClickHandler.bind(this)}
                id="chart"
                style={{ width: "100%", height: "100%", flex: "1" }}
                dataSource={this.state.chartData}
              >
                <CommonAnnotationSettings cornerRadius={10} type="text">
                  <Font color="red" size={12} family="IRANSansMobile(FaNum)" />
                </CommonAnnotationSettings>
                <CommonSeriesSettings type="spline" argumentField="date">
                  <Point
                    hoverMode="allArgumentPoints"
                    size={10}
                    visible={false}
                  />
                  <HoverStyle width={5} />
                  {/* <Spline/> */}
                </CommonSeriesSettings>
                {this.state.energySources.map(function (item) {
                  return (
                    <Series
                      key={item.value}
                      valueField={item.value}
                      name={item.name}
                    />
                  );
                })}
                <ArgumentAxis
                  valueMarginsEnabled={false}
                  discreteAxisDivisionMode="crossLabels"
                >
                  <Grid visible={true} />
                  <Label
                    format="millions"
                    wordWrap="none"
                    overlappingBehavior="rotate"
                  />
                </ArgumentAxis>

                <Crosshair
                  enabled={true}
                  color="#949494"
                  width={3}
                  dashStyle="dot"
                >
                  <Label visible={true} backgroundColor="#949494">
                    <Font
                      color="#fff"
                      size={12}
                      family="IRANSansMobile(FaNum)"
                    />
                  </Label>
                </Crosshair>

                <Legend
                  verticalAlignment="bottom"
                  horizontalAlignment="center"
                  itemTextPosition="bottom"
                  equalColumnWidth={true}
                >
                  <Font
                    color="var(--textcolor1)"
                    family="IRANSansMobile(FaNum)"
                  />
                </Legend>
                <CommonAxisSettings>
                  <Label visible={true}>
                    <Font
                      color="var(--textcolor1)"
                      size={10}
                      family="IRANSansMobile(FaNum)"
                    />
                  </Label>
                </CommonAxisSettings>
                <Tooltip enabled={true} cornerRadius={7} format="fixedPoint">
                  <Font
                    color="var(--textcolor1)"
                    size={12}
                    family="IRANSansMobile(FaNum)"
                  />
                </Tooltip>
              </LineChart>
            )}
            {this.state.isLoading && (
              <div className="loading-inside">
                <MagicSpinner size={70} color="var(--green1)" loading={true} />
                <div style={{ marginTop: "14px", fontSize: "14px" }}>
                  لطفاً شکیبا باشید
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
